<template>
  <v-row>
    <v-dialog class="mx-0" v-model="dialog" persistent max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text large icon v-bind="attrs" v-on="on">
              <v-icon medium color="red lighten-1"> mdi-plus-circle </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-row class="mx-0">
          <v-col cols="12" class="d-flex justify-center">
            <v-card-title>
              <span class="headline">Cadastro de Fornecedor</span>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-form ref="new_provider_form">
            <v-row>
              <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="$v.form.corporative_name.$model"
                  label="Razão Social*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.corporative_name"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="$v.form.fantasy_name.$model"
                  label="Nome Fantasia*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.fantasy_name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="$v.form.cnpj.$model"
                  v-mask="'##.###.###/####-##'"
                  label="CNPJ*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.cnpj"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="$v.form.sic.$model"
                  v-mask="'###########'"
                  label="Sic*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.sic"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeModal()"> Fechar </v-btn>
          <v-btn color="black" text @click="storeProvider()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'

export default {
  name: 'NewProvider',
  directives: { mask },

  data: () => ({
    dialog: false,

    form: {
      fantasy_name: '',
      corporative_name: '',
      sic: '',
      cnpj: '',
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
      },
      data: {
        fantasy_name: [],
        corporative_name: [],
        sic: [],
        cnpj: [],
      },
    },
  }),
  validations: {
    form: {
      fantasy_name: { required },
      corporative_name: { required },
      sic: { required },
      cnpj: { required },
    },
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('acquisitions', ['ActionStoreProvider']),

    async storeProvider() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          treated_form.append('fantasy_name', this.form.fantasy_name)
          treated_form.append('corporative_name', this.form.corporative_name)
          treated_form.append('sic', this.form.sic)
          treated_form.append('cnpj', this.form.cnpj)

          await this.ActionStoreProvider(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Fornecedor cadastrado com sucesso',
          })
          this.closeModal()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }
      this.ActionSetLoading(false)
    },

    closeModal() {
      this.$refs.new_provider_form.reset()
      this.dialog = false
    },

    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>